<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <!-- Brand link (Home) -->
      <router-link class="navbar-brand" to="/home">
        <img src="@/assets/arminas_iraq_logo.jpeg" alt="Logo" class="navbar-logo" />
      </router-link>      
      <!-- Navbar toggle button for small screens -->
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Navbar links -->
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav mx-auto"> <!-- Added 'mx-auto' to center the navbar items -->
          <!-- Customer Dropdown -->
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdownCustomer"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Customer
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdownCustomer">
              <li><router-link class="dropdown-item" to="/customers">List Customers</router-link></li>
              <li><router-link class="dropdown-item" to="/add-customer">Add New Customer</router-link></li>
            </ul>
          </li>

          <!-- Items Dropdown -->
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdownItems"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Items
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdownItems">
              <li><router-link class="dropdown-item" to="/items">List Items</router-link></li>
              <li><router-link class="dropdown-item" to="/add-item">Add New Item</router-link></li>
            </ul>
          </li>

          <!-- Quotes Dropdown -->
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdownQuotes"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Quotes
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdownQuotes">
              <li><router-link class="dropdown-item" to="/quotes">List Quotes</router-link></li>
              <li><router-link class="dropdown-item" to="/add-quote">Create Quote</router-link></li>
            </ul>
          </li>

          <!-- Logout Button (visible if logged in) -->
          <li class="nav-item" v-if="isLoggedIn">
            <router-link to="/" @click.prevent="logout" class="nav-link">Logout</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>


<script>

// bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import { logout } from "@/helper/utils1"; // Use `@` for the src directory


export default {
  components: {
  },
  computed: {
    isLoggedIn() {
      // Check if the token exists in localStorage
      return !!localStorage.getItem('token');
    },
  },
  methods: {
    logout() {
      logout(this.$router); // call helper logout
    },
  },
};
</script>

<style scoped>
.navbar-logo {
  width: 100px; /* Smaller size for the logo */
  height: auto; /* Maintain aspect ratio */
}
nav {
  padding: 10px;
  background-color: #f0f0f0;
  display: flex;
  gap: 10px;
}

router-link {
  text-decoration: none;
  color: #007bff;
} 

router-link:hover {
  text-decoration: underline;

}
</style>
